/* Product metafield accordion — adds a smooth expand and collapse to the native
   <details> element.

   Without JavaScript, or when the visitor prefers reduced motion, the element
   keeps its default instant toggle, so the content is always reachable. */

if (!customElements.get('product-accordion')) {
  customElements.define(
    'product-accordion',
    class ProductAccordion extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('.product-accordion__details');
        this.summary = this.querySelector('.product-accordion__summary');
        this.panel = this.querySelector('.product-accordion__panel');
        if (!this.details || !this.summary || !this.panel) return;

        this.animation = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.summary.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onClick);
        this.animation?.cancel();
      }

      onClick = (event) => {
        // Let the browser handle it natively when motion is not wanted
        if (this.reducedMotion.matches) return;

        event.preventDefault();

        if (this.details.open) {
          this.collapse();
        } else {
          this.expand();
        }
      };

      expand() {
        this.details.open = true;
        this.run(0, this.panel.scrollHeight);
      }

      collapse() {
        this.run(this.panel.scrollHeight, 0, () => {
          this.details.open = false;
        });
      }

      run(from, to, onFinish) {
        this.animation?.cancel();

        this.animation = this.panel.animate(
          {
            height: [`${from}px`, `${to}px`],
            opacity: [from === 0 ? 0 : 1, to === 0 ? 0 : 1],
          },
          {
            duration: 260,
            easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
          }
        );

        this.animation.onfinish = () => {
          this.animation = null;
          this.panel.style.height = '';
          if (onFinish) onFinish();
        };

        this.animation.oncancel = () => {
          this.animation = null;
        };
      }
    }
  );
}
